import React from 'react';

import { MembershipType, PersonOrgSubtype } from '@ndvr/customer-api';

import { FormInput, FormSection, FormSelect, getFieldName, StateSelector, Title, VerticalLayout } from 'widgets';
import { FormDateInput } from 'widgets/form/input/FormDateInput';

import { AddressBlock } from './AddressBlock';
import { AuthorizationFields } from './AuthorizationFields';
import { ComplianceRequirements } from './ComplianceRequirements';
import { FinancialPicture } from './FinancialPicture';
import { MemberSelector } from './MemberSelector';

export const TrustFormFields = ({ prefix = '' }: { prefix?: string }) => {
    return (
        <VerticalLayout $gap={24}>
            <FormSection title="Trust details">
                <FormSelect name={getFieldName('personOrgSubtype', prefix)} label="Trust type">
                    <option></option>
                    <option value={PersonOrgSubtype.REVOCABLE_TRUST}>Revocable</option>
                    <option value={PersonOrgSubtype.IRREVOCABLE_TRUST}>Irrevocable</option>
                    <option value={PersonOrgSubtype.GRANTOR_RETAINED_ANNUITY_TRUST}>GRAT</option>
                </FormSelect>
                <FormInput name={getFieldName('orgName', prefix)} placeholder="Name" label="Trust name" />
                <FormDateInput name={getFieldName('establishedAt', prefix)} label="Date established at" />
                <StateSelector name={getFieldName('orgState', prefix)} label="State organized in" />
            </FormSection>

            <FormSection title="Management authorization" hasDivider>
                <AuthorizationFields prefix={prefix} label="Trust" />
            </FormSection>

            <FormSection hasDivider>
                <VerticalLayout $gap={32}>
                    <Title content>Trust Members</Title>
                    <MemberSelector
                        prefix={prefix}
                        title="Grantors"
                        membershipType={MembershipType.TRUST_GRANTOR}
                        showPercentageField
                    />
                    <MemberSelector prefix={prefix} title="Trustees" membershipType={MembershipType.TRUST_TRUSTEE} />
                    <MemberSelector
                        prefix={prefix}
                        title="Beneficiaries"
                        membershipType={MembershipType.TRUST_BENEFICIARY}
                        showPercentageField
                    />
                    <MemberSelector
                        prefix={prefix}
                        title="Contingent Beneficiaries"
                        membershipType={MembershipType.TRUST_CONTINGENT_BENEFICIARY}
                        showPercentageField
                    />
                </VerticalLayout>
            </FormSection>

            <AddressBlock prefix={prefix} />

            <FormSection title="Financial Picture" hasDivider>
                <FinancialPicture prefix={prefix} />
            </FormSection>

            <FormSection title="Compliance Requirements" hasDivider>
                <ComplianceRequirements prefix={prefix} />
            </FormSection>
        </VerticalLayout>
    );
};
